import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Dialog } from 'src/components/shared/dialog/Dialog';
import { RootState } from 'src/features';
import { FortuneExchangedItem } from 'src/models/fortune/FortuneExchangedItem';
import { FortuneHistoryDetailContent } from './FortuneHistoryDetailContent';

export const FortuneHistoryDetailDialog: React.FC = () => {
  const { exchangeHistory } = useSelector((state: RootState) => state.fortune);

  const params = useParams<{ index: string }>();
  const index = getIndexAsNum(params.index);

  // workaround: ダイアログを閉じる際、URLのパラメータやクエリを参照できなくなってFortuneConfirmContentが非表示になり、
  // ダイアログの高さが変わるのを防ぐために、画面描画にはStateに格納した履歴情報を使用する
  const [historySnapshot, setHistorySnapshot] = useState<FortuneExchangedItem | undefined>(
    undefined
  );

  useEffect(() => {
    if (exchangeHistory?.state === 'ok') {
      if (!historySnapshot && index !== undefined) {
        const targetHistory = exchangeHistory.result.itemHistories[index];
        setHistorySnapshot(targetHistory);
      }
    }
  }, [exchangeHistory, historySnapshot, index]);

  return (
    <Dialog hasHeader={true}>
      {historySnapshot && <FortuneHistoryDetailContent exchangedItem={historySnapshot} />}
    </Dialog>
  );
};

// helper function
function getIndexAsNum(numStr: string) {
  const parsed = parseInt(numStr, 10);

  if (isNaN(parsed)) {
    return undefined;
  }
  return parsed;
}
